import {Injectable} from '@angular/core';
import {ShellClientService} from '../../shell-communication/shell-client.service';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../../shell-communication/operations/shell-protocol-namespace.const';
import {MavenSettingsTemplate} from './maven-settings-template';

class GetAssignedMavenTemplates {
    constructor(public underlying: string) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.GetAssignedMavenTemplates'; }
}
class SaveAssignableMavenTemplate {
    constructor(public template: string) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.SaveAssignableMavenTemplate'; }
}
class RemoveAssignableMavenTemplate {
    constructor(public templateId: string) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.RemoveAssignableMavenTemplate'; }
}
class GetAssignableMavenTemplates {
    constructor(public underlying: string) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.GetAssignableMavenTemplates'; }
}
class AssignMavenTemplates {
    constructor(public templates: MavenTemplateAssignment[]) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.AssignMavenTemplates'; }
}
export interface MavenTemplateAssignment {
    templateId: string;
    name: string;
    underlying: string;
    users: {userId: string; name: string; isSelected: boolean}[];
}
@Injectable({providedIn: 'root'})
export class MavenSharedTemplateClient {
    constructor(private readonly _shell: ShellClientService) {}
    async list(underlying: string): Promise<MavenSettingsTemplate[]> {
        const reply = await this._shell.processQuery<{templates: string[]}>(new GetAssignedMavenTemplates(underlying));
        return (reply.templates || []).map(json => JSON.parse(json))
            .filter(t => (t.version === 1 || t.version === 2) && t.underlying === underlying && t.settings);
    }
    save(template: MavenSettingsTemplate): Promise<void> {
        return this._shell.processCommand(new SaveAssignableMavenTemplate(JSON.stringify(template)));
    }
    remove(id: string): Promise<void> {
        return this._shell.processCommand(new RemoveAssignableMavenTemplate(id));
    }
    async assignments(underlying: string = null): Promise<MavenTemplateAssignment[]> {
        const reply = await this._shell.processQuery<{templates: MavenTemplateAssignment[]}>(new GetAssignableMavenTemplates(underlying));
        return reply.templates || [];
    }
    assign(rows: MavenTemplateAssignment[]): Promise<void> {
        return this._shell.processCommand(new AssignMavenTemplates(rows));
    }
}
